module.exports = __webpack_public_path__ + "img/hedgehog-image.74cf0b83.jpg";